module.exports = __webpack_public_path__ + "img/banner.efe873a3.jpg";